//处理字典数据
export function dealStatus(dictionary,val){
  if(dictionary&&val){
    return dictionary.filter((item) => {
      if (item.dictValue == val) {
        return item;
      }
    }).length > 0
      ? dictionary.filter((item) => {
        if (item.dictValue == val) {
          return item;
        } else {
          return "";
        }
      })[0].dictLabel
      : "";
  }

}
//处理时间格式
export function dealTime(date) {
  if(date){
    date = new Date(date);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let minute = date.getMinutes();
    minute = minute < 10 ? "0" + minute : minute;
    let second = date.getSeconds();
    second = second < 10 ? "0" + second : second;
    if (y <= 2000) {
      return "-";
    } else {
      return m + "-" + d;
    }
  }else{
    return ''
  }

}
//处理时间格式返回秒
export function dealTimeMinute(date) {
  if(date){
    date = new Date(date);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    let d = date.getDate();
    d = d < 10 ? "0" + d : d;
    let h = date.getHours();
    h = h < 10 ? "0" + h : h;
    let minute = date.getMinutes();
    minute = minute < 10 ? "0" + minute : minute;
    let second = date.getSeconds();
    second = second < 10 ? "0" + second : second;
    if (y <= 2000) {
      return "-";
    } else {
      return y + "-" + m + "-" + d+ " "+h+':'+minute+':'+second;
    }
  }else{
    return ''
  }

}
//表格空处理
export function nullFun(data) {
  if (data == null || data == "") {
    return "-";
  } else {
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/utils/formatter.js